import {
    NEW_NOTES_RETRIEVED,
    SET_RECENT_NOTES
} from '../types';

const INITIAL_STATE = {
    customer: {},
    product: {},
    report: {},
    service: {},
    recent: []
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case NEW_NOTES_RETRIEVED:
            return { ...state, [action.bind]: { ...state[action.bind], [action.id]: action.payload } };
        case SET_RECENT_NOTES:
            return { ...state, recent: action.payload }
        default:
            return state;
    }
}